import { createContext } from 'react'

export const ModalsContext = createContext({
	modals: {},
	layers: [],
	activeModal: false,
	openModal: () => {
		console.warn('Modals provider is not set up.');
	},
	closeModal: () => {
		console.warn('Modals provider is not set up.');
	},
});